import { useEffect, useState } from "react"
import { useWatches } from "../../../../context/watchProvider";
import AdminButton from "../../../core/admin/adminButton";
import { adminInputClass } from "../../../core/admin/adminTextInput";
import { formatAdminPrice } from "../../../core/admin/adminWatchSpecs";
import { ImageIcon } from "../../../../img/svg/adminIcons";

export default function DisplayedBanner({ banner, reorder, refresh }: { banner: { [key: string]: any }, reorder: boolean, refresh: () => Promise<null | undefined> }) {

    const { updateWatch } = useWatches();

    const [order, setOrder] = useState(banner.order || 0);
    const [saving, setSaving] = useState(false);

    // ressincroniza com o valor salvo quando a lista é recarregada
    useEffect(() => {
        setOrder(banner.order || 0);
    }, [banner.order])

    const handleOrder = (value: string) => {
        if (!banner?.id) {
            return null;
        }
        if (value === "") {
            setOrder(0);
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        if (parseInt(value) > 99) {
            return null;
        }
        setOrder(value);
    }

    const updateOrder = async () => {
        if (!banner?.id) {
            return null;
        }
        setSaving(true);
        const updateTask = await updateWatch(banner.id, { order });
        setSaving(false);
        if (!updateTask) {
            return null;
        }
        refresh();
    }

    return (
        <div className="flex gap-3 rounded-xl border border-gray-200 bg-white p-3">
            <div className="h-24 w-24 shrink-0 overflow-hidden rounded-lg bg-gray-100 flex items-center justify-center text-gray-300">
                {
                    banner.imgUrl ?
                        <img src={banner.imgUrl} alt="banner" className="h-full w-full object-cover" />
                        : <ImageIcon width="28px" />
                }
            </div>
            <div className="min-w-0 flex-1 flex flex-col">
                <p className="font-bold text-gray-900 truncate">{banner.brand} {banner.model}</p>
                <p className="text-sm text-gray-500">{banner.year} · {formatAdminPrice(banner.price) || "—"}</p>
                <p className="text-xs text-gray-400 truncate mt-0.5">Serial: {banner.serial || "—"}</p>
                <p className="font-mono text-[11px] text-gray-400 truncate">{banner.id}</p>
                {
                    reorder ?
                        <div className="mt-auto pt-2 flex items-center gap-2">
                            <label className="text-xs font-semibold text-gray-600" htmlFor={`order-${banner.id}`}>Posição</label>
                            <input id={`order-${banner.id}`} inputMode="numeric" className={`${adminInputClass} !w-14 h-8 !px-2 text-center`} type="text" value={order} onChange={e => handleOrder(e.target.value)} />
                            <AdminButton size="sm" loading={saving} onClick={updateOrder} disabled={order === banner.order}>Salvar</AdminButton>
                        </div>
                        : null
                }
            </div>
        </div>
    )
}
